export const CHANGE_CURRENT_PAGE = 'productTags/CHANGE_CURRENT_PAGE'
export const CREATE_PRODUCT_TAG = 'productTags/CREATE_PRODUCT_TAG'
export const FETCH_PRODUCT_TAGS_FOR_OPTIONS = 'productTags/FETCH_PRODUCT_TAGS_FOR_OPTIONS'
export const FETCH_PRODUCT_TAGS_LIST = 'productTags/FETCH_PRODUCT_TAGS_LIST'
export const REMOVE_PRODUCT_TAG = 'productTag/REMOVE_PRODUCT_TAG'
export const UPDATE_PRODUCT_TAG = 'productTag/UPDATE_PRODUCT_TAG'
